// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".img-fluid[data-v-f91f76bc]{max-height:200px}", ""]);
// Exports
module.exports = exports;
